"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("src/context/context");
const MyStructureBranches_1 = tslib_1.__importDefault(require("./MyStructureBranches"));
const StructuralHierarchy_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/StructuralHierarchy"));
const MyStructureTree = ({ hook }) => {
    const isFirstLoad = (0, react_1.useRef)(true);
    const [fetchingHierarchy, setFetchingHierarchy] = (0, react_1.useState)(null);
    const [ancestors, setAncestors] = (0, react_1.useState)(null);
    const { toast } = (0, context_1.useToastContext)();
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        if (isFirstLoad.current && hook.state.data.length > 0) {
            openParent(hook.state.data[0]);
            isFirstLoad.current = false;
        }
        return () => abortController.abort();
    }, [hook.state.data]);
    const openParent = (parent) => {
        if (parent.hasChildren) {
            hook.getChildren(parent.id, !!parent.children.length, parent.identifier).then();
        }
    };
    const closeParent = (parentStructuralUnit) => {
        hook.closeStructuralUnit(parentStructuralUnit.identifier);
    };
    const handleOpenHierarchy = async (item) => {
        setFetchingHierarchy(item.identifier);
        const response = await hook.getAncestors(item.id);
        setFetchingHierarchy(null);
        if (!response.errors) {
            response.data && setAncestors({ data: response.data, item });
        }
        else {
            response.errors.forEach(el => toast.danger(el.message));
        }
    };
    if (hook.state.data.length === 0) {
        return (0, jsx_runtime_1.jsx)("div", { children: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0" });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'tree-demo jstree jstree-4 jstree-default', children: [(0, jsx_runtime_1.jsx)("ul", { className: 'jstree-container-ul jstree-children jstree-contextmenu', children: (0, jsx_runtime_1.jsx)(MyStructureBranches_1.default, { hook: hook, openParent: openParent, closeParent: closeParent, structuralUnits: hook.state.data, handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy }) }), ancestors?.data ? ((0, jsx_runtime_1.jsx)(StructuralHierarchy_1.default, { closeForm: () => setAncestors(null), ancestors: ancestors })) : null] }));
};
exports.default = MyStructureTree;
